import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { registerServiceWorker } from './ui/pwa';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

// Offline shell for the installed app. A no-op in development, on purpose —
// see registerServiceWorker.
registerServiceWorker();

createRoot(container).render(
  // StrictMode double-invokes effects in development. The game's effect is
  // idempotent (it disposes on cleanup and rebuilds), so this is safe and it
  // catches lifecycle mistakes early.
  <StrictMode>
    <App />
  </StrictMode>,
);
